import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import hexToRgbA, { hexToRgba, lightOrDark } from "../HexToRGBA";

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const glow = keyframes`
  0%, 100% { box-shadow: 0 0 15px rgba(255, 105, 120, 0.2), 0 0 30px rgba(255, 105, 120, 0.1); }
  50% { box-shadow: 0 0 25px rgba(255, 105, 120, 0.4), 0 0 45px rgba(255, 105, 120, 0.2); }
`;

export const CardContainer = styled.div`
 background: ${props => hexToRgba(props.accentColor,0.3)};
  border: 1px solid rgba(255, 105, 120, 0.15);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-8px);
    border-color: ${props => props.color};
     background: ${props => hexToRgba(props.accentColor,0.6)};

    box-shadow: 0 0 25px ${props => props.color}4d;
  }

  &::before, &::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #080c16;
    border-radius: 50%;
    top: 60%;
    z-index: 5;
  }
  &::before { left: -10px; }
  &::after { right: -10px; }
`

export const CardImg = styled.div`
display: flex;
cursor: pointer;
justify-content: center;
align-content: center;
background: url(${props => props.src}) center;
background-size: cover;
background-position: center;
background-color: ${props => props?.background && props?.background};
width: 15rem;
height: 15rem;
border-radius: 0.5rem;
margin-bottom: 8px;
transition: transform 500ms ease;

&: hover{
    transform: scale(1.02);
  }
     
`

export const PlayContainer = styled.div` 
display: none;
width: 100%;
height: 100%;
justify-content: center;
align-items: center;

${CardImg}: hover &{
   display: flex;
}

`
export const SmallPlayContainer = styled.div` 
display: flex;
width: 100%;
justify-content: center;
align-items: center;

${CardContainer}: hover &{
   display: flex;
}

@media screen and (max-width: 960px) {
    display: flex;
}
`

export const PlayButton = styled.div`
display: flex;
font-size: 0.8rem;
position: absolute;
justify-self: center;
align-self: center;
align-content: center;
color : ${props => props.theme.accentColor};
background: transparent;
transition: 0.8s all ease;
cursor: pointer;
&:hover {
    color: ${props => props.theme.mainColor };
    transition: all 0.2s ease-in-out;
    transform: scale(0.9);
    border-radius: 50%;
    border: 3px solid ${props => props.theme.secondaryBg};

}


`

export const CardContent = styled.div`
    display: flex;
    font-size: 0.8rem;
    padding: 2% 3%;
    flex-direction: column;
    justify-content: space-evenly;

`

export const CardTitle = styled.h4`
    display: flex;
    font-size: 1rem;
    margin-bottom: 2%;
    white-space: normal;
    word-wrap: break-word;
    text-align: left;
    color: ${props => props.theme.secondaryColor};

`

export const CreatorInfoWrapper = styled.div`
    display: flex;
    cursor: pointer;
    gap: 0.7rem;
    align-items: center;
    margin-bottom: 3%;
`

export const CreatorImg = styled.div`
    display: flex;
    cursor: pointer;
    padding: 1%;
    background: url(${props => props.src});
    background-size: cover;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    transition: transform 500ms ease;


`

export const CreatorInfo = styled.div`
    display: flex;
    font-size: 0.9rem;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    width: 100%;
`

export const CreatorInfoContent = styled.div`
    display: flex;
    flex-direction: column;
    
`
export const H6 = styled.h6`
    font-size: 0.8rem;
    color: ${props => hexToRgba(props.theme.accentColor, 1)};
`

export const InfoContentText = styled.div`
    display: flex;
    white-space: normal;
    color: ${props => props.theme.secondaryBg};
    word-wrap: break-word;
`

export const TextLink = styled(Link)`
text-decoration: none;
cursor: pointer;
color: ${props => props?.alt ? props?.theme?.secondaryColor : props.theme.secondaryBg};
&: hover{
 color: ${props => props?.alt ? props.theme.secondaryBg : props.theme.accentColor};
 text-decoration: underline;

}
`

export const FloatingIcon = styled.div`
  font-size: 3rem;
  filter: drop-shadow(0 10px 8px rgba(0, 0, 0, 0.4));
  animation: ${pulse} 3s infinite ease-in-out;
`;

export const CardValueBadge = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  background-color:${props => hexToRgba(props.theme.secondaryBg,0.83)};
  border: 1px solid ${props => hexToRgba(props.theme.secondaryColor,0.1)};
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 800;
  color: ${props => props.theme.secondaryBg};
`;

export const VoucherTitle = styled.h3`
  font-size: 1rem;
  font-weight: 900;
  white-space: wrap;
  color: ${props => props.theme.secondaryBg};
  margin: 0 0 8px 0;
`;

export const VoucherDescription = styled.p`
  font-size: 11px;
  color:${props => props.theme.accentColor};
  line-height: 1.625;
  white-space: wrap;
  margin: 0;
`;

export const DividerLine = styled.div`
  border-top: 1px dashed ${props => hexToRgba(props.theme.accentColor,0.1)};
  margin: 16px 0;
`;

export const PriceTag = styled.div`
  font-size: 1.5rem;
  font-weight: 900;
  color: ${props => props.theme.secondaryBg};
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 4px;

  span {
    font-size: 0.75rem;
    color: ${props => props.theme.secondaryColor};
    font-weight: 600;
  }
`;

export const PurchaseButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, ${props => props.btnColor || props.theme.mainColor} 0%, ${props => hexToRgba(props.theme.secondaryColor,0.6)} 100%);
  color:${props => props.theme.secondaryBg};
  border: none;
  padding: 12px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;


export const BuyButton = styled.div`
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: 0.7rem;
    padding: 5px 22px;
    background: transparent;
    border: 1px solid ${props => props.theme.mainColor};
    color: ${props => props.theme.secondaryBg};
    font-size: 0.8rem;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    text-wrap: noWrap;
    transition: transform 500ms ease;
    &: hover{
        background: ${props => props.theme.mainColor};
        border: 1px solid ${props => props.theme.mainColor};
        color: ${ props => lightOrDark(props.theme.mainColor) === 'light' ? 'black' : 'white'};

    }
    ${CardContainer}:hover &{
        border: 1px solid ${props => props.theme.accentColor};

    }

    `

    const SkeletonLoading = keyframes`

    0%{
        background-color: ${ hexToRgba(	'#a3b8c2', 0.3)};
    }
    100%{
        background-color: ${ hexToRgba(	'#f0f3f5', 0.3)};
    }`


export const SkeletonPurchaseCardImg = styled(CardImg)`
animation: ${props => !props.color && SkeletonLoading} 1s linear infinite alternate;`